export enum Registry {
  BrandMediaDefaultLayout = 'BrandMediaDefaultLayout',
  ChatLayout = 'ChatLayout',
  ChatCloseButton = 'ChatCloseButton',
  SearchPopup = 'SearchPopup',
  HeaderOld = 'HeaderOld',
}
// prettier-ignore
export const registry: Record<Registry, any> = {
  [Registry.BrandMediaDefaultLayout]: () => import('@/components/BrandMedia/Layouts/BrandMediaDefaultLayout.vue'),
  [Registry.ChatLayout]: () => import('@/components/SearchPopup/new-design/chat-section/ChatLayout.vue'),
  [Registry.ChatCloseButton]: () => import('@/components/SearchPopup/new-design/chat-section/ChatCloseButton.vue'),
  [Registry.SearchPopup]: () => import('@/components/SearchPopup/SearchPopup.vue'),
  [Registry.HeaderOld]: () => import('@/components/Header/HeaderOld.vue'),
}

const componentPlaceholder = (name) => ({
  template: `<div>Component ${name} not found</div>`,
})

export const getRegistryComponents = (store) => {
  const result = {}

  Object.keys(registry).forEach((key) => {
    result[key] = async () => {
      const loader = registry[key]
      if (!loader) return componentPlaceholder(key)
      if (store.getters['registry/getRegistry'][key]) {
        return await loader()
      }
      return componentPlaceholder(key)
    }
  })

  return result
}
